export const MAX_FILE_SIZE = 500 * 1024 * 1024 // 500 MB in bytes
export const ALLOWED_FILE_TYPES = ['pdf', 'doc', 'docx']
